import gql from "graphql-tag";
import getQuery from "./get_query";
import ParcisionCookies from "../../../utils/Cookies";

export default async function encryptPortfolio(pid: number, phash: string, rhash: string, description: string) {
  const address = ParcisionCookies.get("address");
  const variables = {
    pid,
    phash,
    rhash,
    description,
    address,
  };

  const query = gql`
    query MyQuery($pid: Float!, $phash: String!, $rhash: String!, $description: String!, $address: String!) {
      encryptPortfolio(pid: $pid, phash: $phash, rhash: $rhash, description: $description, address: $address) {
        phash
        rhash
        description
      }
    }
  `;

  const data = await getQuery(query, variables);
  // @ts-expect-error
  return data.encryptPortfolio;
}
